<template>
  <div> 
    <modalUpload @save="saveFile"> </modalUpload>
 
 
<!-- Início do menu mobile -->
    <b-sidebar 
      ref="sidebarMenu"
      id="sidebar-menu" 
      no-header 
      backdrop-variant="dark" 
      backdrop 
      shadow
      width='220px'
    > 
      <div class='card-header d-flex justify-content-between'>
        <a v-text="$ml.get('navigation')">Navegação</a>
        <a @click="closeSidebarMenu" role="button" class="row justify-content-start pointer">
          <img src="../../../src/assets/icons/times-circle.svg" class="ico-15"/>
        </a>  
      </div>
 
      <div class='card-body pl-0'>
        <ul class='none-p-m profile-nav'>
          <li @click="alterMenu('home')">
            <a :class='itemMenu == "home" ? "px-3 active " : "px-3"'
              v-text="$ml.get('menuAccount')">
              Minha Conta
            </a>  
          </li>
          <li v-if="user.typeUser == 'company' && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('company')">
            <a :class='itemMenu == "company" ? "px-3 active " : "px-3"'
              v-text="$ml.get('myBusiness')">
              Minha empresa
            </a>  
          </li>
          <li v-if="user.typeUser == 'company'" @click="alterMenu('user')">
            <a :class='itemMenu == "user" ? "px-3 active " : "px-3"'
              v-text="$ml.get('users')">
              Usuários
            </a>  
          </li> 
    
          <li v-if="user.typeUser == 'company'" @click="alterMenu('invoices')">
            <a :class='itemMenu == "invoices" ? "px-3 active " : "px-3"'
              v-text="$ml.get('invoices')">
              Faturamento
            </a>  
          </li>
          <li v-if="user.typeUser == 'hacker'" @click="alterMenu('revenues')">
            <a :class='itemMenu == "revenues" ? "px-3 active " : "px-3"'>
              Wallet
            </a>  
          </li>
  
          <li @click="alterMenu('access')">
            <a :class='itemMenu == "access" ? "px-3 active " : "px-3"'
              v-text="$ml.get('access')"> Acessos 
            </a>   
          </li>
          <li @click="alterMenu('terms')">
            <a :class='itemMenu == "terms"? "px-3 active " : "px-3"'
              v-text="$ml.get('termsAPolicy')">
              Termos e Política
            </a> 
          </li>
          <li @click="alterMenu('authentication')">
            <a :class='itemMenu == "authentication"? "px-3 active " : "px-3"'
              v-text="$ml.get('authentication')">
              Autenticação
            </a> 
          </li>
          <li>
            <a @click="logoff()" class='px-3' 
              v-text="$ml.get('exit')">Sair</a>
          </li>
        </ul>
      </div>  
    </b-sidebar>
  
    <a id="btn-float-mobile" v-b-toggle.sidebar-menu class="d-md-none btn" role="button">
      <svg width="20" height="20" class="mb-1">       
        <image xlink:href="../../../src/assets/icons/bars.svg" width="20" height="20"/>    
      </svg>
    </a>   
<!-- Fim -->
    <div class='card mb-3 profile-interno'> 
      <div v-if="user.typeUser == 'company'" class='card-body p-3 pb-4 d-flex flex-column justify-content-center align-items-center'>  
        <span class='position-relative'>
          <div @click="showModal()" class="avatar-wrapper mb-3">
   
          <object v-show="!this.optionsMenusPersonal.includes(itemMenu)" v-if="user.company_avatar" class="profile-pic mb-3" :data='user.company_avatar' type="image/png">
            <img  class="profile-pic mb-3" src="../../assets/images/default.png" alt="Avatar hacker">
          </object>

          <object v-show="this.optionsMenusPersonal.includes(itemMenu)" v-if="user.account_avatar" class="profile-pic mb-3" :data='user.account_avatar'  type="image/png">
            <img class="profile-pic mb-3" src="../../assets/images/default.png" alt="Avatar hacker">
          </object>

          </div>
          <a @click="showModal()" class='ico-edit camUpload pointer'>
            <svg width="16" height="16" class="m-1">       
              <image xlink:href="../../../src/assets/icons/camera.svg" width="16" height="16"/>    
            </svg> 
          </a>
        </span> 
        <h6 class='m-0 p-0 title-max-width' v-text="!this.optionsMenusPersonal.includes(itemMenu) ? user.companyName : user.name"></h6>

        <span v-if="!this.optionsMenusPersonal.includes(itemMenu) && user.company_createdAt" class='text-muted' v-text="$ml.with($utils.formatDataShort(user.company_createdAt).substring(0,10)).get('since')">Desde </span>
        <span v-else-if="user.account_createdAt" class='text-muted' v-text="$ml.with($utils.formatDataShort(user.account_createdAt).substring(0,10)).get('since')">Desde </span>
        <hr v-show="!this.optionsMenusPersonal.includes(itemMenu)" class='w-100 mt-3 mb-3'/>
        <div v-show="!this.optionsMenusPersonal.includes(itemMenu)">  
          <div class="row">
            <span class="pr-2"><font v-text="$ml.get('public')">Publicos</font>: <strong>{{amount_programs.public}}</strong></span>
            <span ><font v-text="$ml.get('private')">Privados</font>: <strong>{{amount_programs.private}}</strong></span> 
          </div>
        </div> 
      </div>

      <div v-else class='card-body p-3 pb-4 d-flex flex-column justify-content-center align-items-center'>  
        <span class='position-relative'>
          <div v-if="user.verified" class="verify"> 
            <img src="../../../src/assets/icons/badge-check.png" width="32" height="32" />
          </div>
          <div @click="showModal()" class="avatar-wrapper mb-3"> 
            <object class="profile-pic mb-3" v-if="user.account_avatar" :data='user.account_avatar'  type="image/png">
              <img class="profile-pic mb-3" src="../../assets/images/default.png" alt="Avatar">
            </object>
          </div>
          <a @click="showModal()" class='ico-edit camUpload pointer'>
            <svg width="16" height="16" class="m-1">       
              <image xlink:href="../../../src/assets/icons/camera.svg" width="16" height="16"/>    
            </svg>
          </a>
        </span> 
         <h6 class='m-0 p-0 title-max-width' v-text="user.username"></h6>
         <span v-if="user.account_createdAt" v-text="$ml.with($utils.formatDataShort(user.account_createdAt).substring(0,10)).get('since')">Desde </span>
        <hr class='w-100 mt-3 mb-3'/> 
        <div class="row">
          <span ><strong>{{user.score ? user.score : 0}}</strong> <font v-text="$ml.get('points')">Pontos</font></span>
          <span class="px-2">|</span>
          <span><strong>{{user.amount_of_reports ? user.amount_of_reports : 0}}</strong> <font v-text="$ml.get('report')">Relatório</font>{{user.amount_of_reports > 1 ? 's' : ''}}</span> 
        </div> 
      </div>
    </div>
  
    <div class='card card-visitors d-none d-md-flex'> 
      <div class='card-header'>
        <span v-text="$ml.get('user')"></span>
      </div>
      <div class='card-body p-0'>
        <ul class='none-p-m profile-nav'>
          <li @click="alterMenu('home')">
            <a :class='itemMenu == "home" ? "px-3 active " : "px-3"'
              v-text="$ml.get('menuAccount')">
              Minha Conta
            </a>  
          </li>
            <li id="menuIdAuthentication" @click="alterMenu('authentication')">
              <a :class='itemMenu == "authentication"? "px-3 active " : "px-3"'
                v-text="$ml.get('authentication')">
                Autenticação
              </a>
            </li>
            <li @click="alterMenu('locker')" v-if="two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company' && this.$store.getters['getUser'].role != 'owner'">
              <a :class='itemMenu == "locker"? "px-3 active " : "px-3"' v-text="$ml.get('menuLocker')">
                Cofre de Relatórios
              </a> 
           </li>
            <li @click="alterMenu('locker')" v-if="!two_factor_auth_required && user.typeUser == 'company' && this.$store.getters['getUser'].role != 'owner'">
              <a :class='itemMenu == "locker"? "px-3 active " : "px-3"' v-text="$ml.get('menuLocker')">
                Cofre de Relatórios
              </a> 
           </li>
           <li @click="alterMenu('locker')" v-if="user.typeUser == 'hacker'">
            <a :class='itemMenu == "locker"? "px-3 active " : "px-3"' v-text="$ml.get('menuLocker')">
              Cofre de Relatórios
            </a> 
           </li>
          <li v-if="user.typeUser == 'hacker'" @click="alterMenu('revenues')">
            <a :class='itemMenu == "revenues" ? "px-3 active " : "px-3"'>
              Wallet
            </a>  
          </li>
          <li v-if="user.typeUser == 'hacker'"  @click="alterMenu('access')">
            <a :class='itemMenu == "access" ? "px-3 active " : "px-3"' v-text="$ml.get('access')"> 
              Acessos 
            </a>   
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company'"  @click="alterMenu('access')">
            <a :class='itemMenu == "access" ? "px-3 active " : "px-3"' v-text="$ml.get('access')"> 
              Acessos 
            </a>   
          </li>
          <li v-if="!two_factor_auth_required && user.typeUser == 'company'"  @click="alterMenu('access')">
            <a :class='itemMenu == "access" ? "px-3 active " : "px-3"' v-text="$ml.get('access')"> 
              Acessos 
            </a>   
          </li>
          <li v-if="user.typeUser == 'hacker'" @click="alterMenu('vpns')">
            <a :class='itemMenu == "vpns" ? "px-3 active " : "px-3"'> 
              Links VPN
            </a>   
          </li>
          <li v-if="user.typeUser == 'hacker'" @click="alterMenu('terms')">
            <a :class='itemMenu == "terms"? "px-3 active " : "px-3"'
              v-text="$ml.get('termsAPolicy')">
              Termos e Política
            </a> 
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company'" @click="alterMenu('terms')">
            <a :class='itemMenu == "terms"? "px-3 active " : "px-3"'
              v-text="$ml.get('termsAPolicy')">
              Termos e Política
            </a> 
          </li>
          <li v-if="!two_factor_auth_required && user.typeUser == 'company'" @click="alterMenu('terms')">
            <a :class='itemMenu == "terms"? "px-3 active " : "px-3"'
              v-text="$ml.get('termsAPolicy')">
              Termos e Política
            </a> 
          </li>

          
          <li v-show="user.typeUser == 'hacker'">
            <a @click="logoff()" class='px-3' v-text="$ml.get('exit')"></a>
          </li>
        </ul>
      </div> 
    </div>
    <div v-if="user.typeUser != 'hacker'" class='card card-visitors d-none d-md-flex' style="margin-top: 0.6rem">
      <div class='card-header'>
        <span v-text="$ml.get('company')"></span>
      </div>
      <div class='card-body p-0'>
        <ul class='none-p-m profile-nav'>
          <li v-if="user.typeUser == 'company' && two_factor_auth_required && two_factor_auth_login && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('company')">
            <a :class='itemMenu == "company" ? "px-3 active " : "px-3"' 
            v-text="$ml.get('myBusiness')">
              Minha empresa              
            </a>  
          </li>
          <li v-if="user.typeUser == 'company' && !two_factor_auth_required && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('company')">
            <a :class='itemMenu == "company" ? "px-3 active " : "px-3"' 
              v-text="$ml.get('myBusiness')">
              Minha empresa
            </a>  
          </li>
          <li @click="alterMenu('locker')" v-if="user.typeUser == 'company' && two_factor_auth_required && two_factor_auth_login && ['owner'].includes(this.$store.getters['getUser'].role)">
            <a :class='itemMenu == "locker"? "px-3 active " : "px-3"' v-text="$ml.get('menuLocker')">
              Cofre de Relatórios
            </a> 
          </li>
          <li @click="alterMenu('locker')" v-if="user.typeUser == 'company' && !two_factor_auth_required && ['owner'].includes(this.$store.getters['getUser'].role)">
            <a :class='itemMenu == "locker"? "px-3 active " : "px-3"' v-text="$ml.get('menuLocker')">
              Cofre de Relatórios
            </a> 
          </li>
          <li @click="alterMenu('authenticationCompany')" v-if="user.typeUser == 'company' && two_factor_auth_required && two_factor_auth_login && ['owner'].includes(this.$store.getters['getUser'].role)">
            <a :class='itemMenu == "authenticationCompany"? "px-3 active " : "px-3"' v-text="$ml.get('authentication')">
              Autenticação
            </a> 
          </li>
          <li @click="alterMenu('authenticationCompany')" v-if="user.typeUser == 'company' && !two_factor_auth_required && ['owner'].includes(this.$store.getters['getUser'].role)">
            <a :class='itemMenu == "authenticationCompany"? "px-3 active " : "px-3"' v-text="$ml.get('authentication')">
              Autenticação
            </a> 
          </li>
          <li  v-if="user.typeUser == 'company' && two_factor_auth_required && two_factor_auth_login" @click="alterMenu('user')">
            <a :class='itemMenu == "user" ? "px-3 active " : "px-3"'
              v-text="$ml.get('users')">
              Usuários
            </a>  
          </li> 
          <li id="menuIdUser" v-if="user.typeUser == 'company' && !two_factor_auth_required" @click="alterMenu('user')">
            <a :class='itemMenu == "user" ? "px-3 active " : "px-3"'
              v-text="$ml.get('users')">
              Usuários
            </a>  
          </li> 

          <li v-if="user.typeUser == 'company' && two_factor_auth_required && two_factor_auth_login" @click="alterMenu('invoices')">
            <a :class='itemMenu == "invoices" ? "px-3 active " : "px-3"'
              v-text="$ml.get('invoices')">
              Faturamentos
            </a>  
          </li>
          <li v-if="user.typeUser == 'company' && !two_factor_auth_required" @click="alterMenu('invoices')">
            <a :class='itemMenu == "invoices" ? "px-3 active " : "px-3"'
              v-text="$ml.get('invoices')">
              Faturamentos
            </a>  
          </li>
          <li v-if="integration && two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company' && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('integration')">
            <a :class='itemMenu == "integration" ? "px-3 active " : "px-3"'
              v-text="$ml.get('integration')">
              Integração
            </a>  
          </li>
          <li v-if="integration && !two_factor_auth_required && user.typeUser == 'company' && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('integration')">
            <a :class='itemMenu == "integration" ? "px-3 active " : "px-3"'
              v-text="$ml.get('integration')">
              Integração
            </a>  
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company' && ['owner','administrator', 'analyst'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('tags')">
            <a :class='itemMenu == "tags" ? "px-3 active " : "px-3"' >
              Tags
            </a>  
          </li>
          <li v-if="!two_factor_auth_required && user.typeUser == 'company' && ['owner','administrator', 'analyst'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('tags')">
            <a :class='itemMenu == "tags" ? "px-3 active " : "px-3"' >
              Tags
            </a>  
          </li>
          <li v-if="two_factor_auth_required && two_factor_auth_login && user.typeUser == 'company' && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('defaultMessageSetup')">
            <a :class='itemMenu == "defaultMessageSetup" ? "px-3 active " : "px-3"' v-text="$ml.get('defaultMessageCenterMenu')">
              Central de Mensagens Padrão
            </a>  
          </li>
          <li v-if="!two_factor_auth_required && user.typeUser == 'company' && ['owner','administrator'].includes(this.$store.getters['getUser'].role)" @click="alterMenu('defaultMessageSetup')">
            <a :class='itemMenu == "defaultMessageSetup" ? "px-3 active " : "px-3"' v-text="$ml.get('defaultMessageCenterMenu')">
              Central de Mensagens Padrão
            </a>  
          </li>
          <li>
            <a @click="logoff()" class='px-3' v-text="$ml.get('exit')">Sair</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import UploadService from "../../services/upload.service";  
import { mapActions } from "vuex";
import $ from 'jquery'
import modalUpload from '../modalUpload.vue';
 
export default {
  props: {
    integration: {
      type: Boolean,
      required: false,
      default: false
    },
    itemMenu: {
      type: String,
      required: true,
      default: 'home',
    },
  },
  components: { modalUpload },
  data() {
    return {  
      user: {
        nameUser: '', 
        typeUser: '',
      },  
      planSelected: '',
      amount_programs: [],
      two_factor_auth_required:"",
      two_factor_auth_login: "",
      optionsMenusPersonal: ['home', 'access', 'terms', 'authentication'],
    };
  },
  watch:{
    "$store.getters.getTwoFactorAuthLogin": function () {
      this.two_factor_auth_login = this.$store.getters['getTwoFactorAuthLogin'];
    },
    '$store.getters.getUser': {
      handler(newVal) {
        this.user.name = newVal.name;
        this.user.username = newVal.username;
      },
      deep: true, // Se necessário, dependendo da estrutura do objeto retornado pelo getter
    },
  },
  mounted(){  
    const authentication = this.$route.params.authentication;
    if(authentication){
      this.alterMenu('authentication');
    } 
    
    this.two_factor_auth_required = this.$store.getters['getTwoFactorAuthRequired'];
    this.two_factor_auth_login = this.$store.getters['getTwoFactorAuthLogin'];
    this.user = this.$store.getters['getUser']; 
    this.planSelected = this.$store.getters['getUser'].plan?.name;
    this.user.typeUser = this.$store.getters['getUserType']; 
    this.amount_programs = this.$store.getters['getAmount_programs'];

  },
  methods: {
    ...mapActions(["setUser","resetUser"]),

    closeSidebarMenu(){
      this.$refs.sidebarMenu.hide(); 
    },

    showModal(){
      this.$bvModal.show('modal-upload-avatar')
      setTimeout(() => {
        $("#avatarEditorCanvas").click();
      }, 50);
    }, 

    saveFile(file){
 
      if(this.user.typeUser == 'company'){
        this.uploadAvatar(file);
        return
      }
      this.uploadAvatarHacker(file);
    }, 
 
    uploadAvatarHacker(file){  
 
      const formData = new FormData(); 

      formData.append("file", file.file);  

      UploadService.postAvatarHacker(formData).then(
        (response) => {  
          this.setUser({   
            account_avatar: response.data, 
          });
          this.user.account_avatar = false;
          setTimeout(() => {
            this.user.account_avatar = response.data 
          }, 200); 
        }
      ); 
     
    }, 

    uploadAvatar(file){   
  
      const formData = new FormData(); 
      formData.append("file", file.file); 
      
      let type = this.itemMenu == 'home' ? 'member' : 'company';

      UploadService.postAvatar(formData,type).then(
        (response) => {
  
          if(this.optionsMenusPersonal.includes(this.itemMenu)){
            this.setUser({  
              account_avatar: response.data, 
            });
            this.user.account_avatar = false;
            setTimeout(() => {
              this.user.account_avatar = response.data 
            }, 200); 
          }else{
            this.setUser({   
              company_avatar: response.data, 
            });
            this.user.company_avatar = false;
            setTimeout(() => {
              this.user.company_avatar = response.data 
            }, 200); 
          }
        } 
      );
    }, 

    alterMenu(menu) {
      this.$emit('alterSelectedMenu', menu); 
      this.closeSidebarMenu();
    },
 
    logoff() {  
      this.resetUser();  
      localStorage.removeItem('token_safe');
      this.$router.push('/login');
    },
 
  },
};
</script>
  
<style scoped>

  .profile-nav li {
    cursor: pointer;
  }
  .avatar-wrapper{ 
    height: 120px;
    width: 120px;  
    z-index: 0;
  }

  .ico-edit {
    margin-top: -21px;
    right: -13px !important;
    background: rgba(255, 255, 255, 0.367) !important;
  }
  .ico-edit i{
    background:transparent !important;
  }

  .verify{
    z-index: 99;
    right: -10px !important;
  } 
  .title-max-width{
    width:100%;
    max-width: 250px;
    text-align: center;
  }
</style>